
<div class="dg-modal-header">
    <h2>{{ isEditMode ? 'edit ' : '' }}photo</h2>
    <i (click)="action(true)" class="close-icon icon-cross_16px"></i>
</div>
<div class="dg-modal-body">
        <h5><b appEllipsisTooltip>{{card.fullEmployeeName }}</b></h5>

    <ng-container *ngIf="!isEditMode">
            <div class="dg-modal-body__image-block">
                <img *ngIf="card.photoGuid" [id]= "'viewImage_' + card.badgeRequestId" [src]="imageSource"  alt="{{card.fullEmployeeName}}">
                <img *ngIf="!card.photoGuid" src="./assets/img/components/photo-review-grid-item/noPhoto.png" alt="{{card.fullEmployeeName}}">
            </div>
        <ng-container *ngIf="!hideActionButtons">
            <ng-container *ngIf="isApproveAndDeclineButton || isFurtherReviewButton">
                <h4><b>Change photo status to</b></h4>
                <div class="dg-modal-body__controls">
                    <ng-container *ngIf="isApproveAndDeclineButton">
                        <button class="button green" (click)="onApprovePhotoCallback()">Approved</button>
                        <button class="button red" (click)="onDeclinePhotoCallback()">Resubmission pending</button>
                    </ng-container>
                    <div *ngIf="isApproveAndDeclineButton && isFurtherReviewButton" class="divider"></div>
                    <button *ngIf="isFurtherReviewButton" class="button secondary" (click)="furtherPhotoReviewCallback()">Further review</button>
                </div>
            </ng-container>
        </ng-container>
     </ng-container>

    <ng-container *ngIf="isEditMode">
        <div class="dg-modal-body__image-block" id="cropper-modal" >
            <div class="modal-body">
                <div class="cropper-img-container">
                    <img #image
                         id="cropper-image"
                         crossorigin="anonymous"
                         (load)="cropperInit(image)"
                         [src]="originalImageSource | safe:'resourceUrl'"
                    >
                  
                    <div class="clearfix"></div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="clearfix"></div>
        <div class="edit-mode-controls">
            <div class="edit-mode-controls__group">
                 <p>Rotate</p>
                <button class="edit-mode-controls__group__item button secondary" (click)="rotate(-90)">
                    <span class="icon-left-up"></span>
                </button>
                <button class="edit-mode-controls__group__item button secondary" (click)="rotate(90)">
                    <span class="icon-right-up"></span>
                </button>
            </div>
            <div class="edit-mode-controls__group">
                <p>Width (px)</p>
                <span class="edit-mode-controls__group__value">{{ getCropperViewData.width }}</span>
            </div>
            <div class="edit-mode-controls__group">
                <p>Height (px)</p>
                <span class="edit-mode-controls__group__value">{{ getCropperViewData.height }}</span>
            </div>
            
        </div>
        <div *ngIf="!isCorrectData && isDirty" class="error-text">The min size of photo is 250*375px</div>
    </ng-container>
</div>

<div class="dg-modal-footer display-block">
    <ng-container *ngIf="isEditMode">
        <button (click)="savePhoto()" [disabled]="!isCorrectData" appTrackClickButton id="save-photo" type="button" class="button primary float-right">Save photo</button>
        <button (click)="action(true)" appTrackClickButton id="cancel-editing" type="button" class="button secondary float-right">Cancel editing</button>
        <button *ngIf="card.croppInfo?.length" (click)="onResetToOriginal()" appTrackClickButton id="reset-to-original" type="button" class="button text float-left">Reset to original</button>
    </ng-container>

    <ng-container *ngIf="!isEditMode">
        <button *ngIf="isVisibleEditPhotoBtn"
                type="button"
                class="button-edit-mode button text"
                (click)="onPhotoReview()">
            <span class="icon-edit pr-2"></span>
            Edit photo
        </button>
        <button (click)="action(true)" appTrackClickButton id="dismiss" type="button" class="button secondary">{{ buttonsTitle.dismiss }}</button>
    </ng-container>


    <div class="clearfix"></div>
</div>
